import React from 'react';

type Props = {
	color?: string;
};

export default function GridSpace({ color }: Props) {
	return (
		<div
			className="min-w-[30px] min-h-[30px] rounded-lg"
			style={{
				backgroundColor: color || '',
			}}></div>
	);
}
